<template>
  <c-button ref="button" v-bind="$props"></c-button>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin, baseComponents } from '@tencent/ceiba-base-components';
// import { componentBaseMixin, baseComponents } from '../../../../ceiba-base-components';
import button from '@tencent/ceiba-act-public-button';

export default {
  name: 'CPopupRedpacketRecord',
  components: {
    [button.name]: button,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'popup-redpacket-record-',
    };
  },
  computed: {},
  async mounted() {
    console.log('configurationData=', this.configurationData);
    await this.initialize();
  },
  methods: {
    async initialize() {
      this.$refs.button.setClickHandler(this.doGetReward, {
        forceLogin: true,
      });
    },
    async doGetReward() {
      this.reportClick({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
      });
      const params = {
        // activity_id: `${this.actInfo.activity_id}`,
        // gameCode: this.configurationData.game_code ? this.configurationData.game_code : this.actInfo.game_code,

        business: this.configurationData.redPacketAst || '', // 业务
        uuid: this.configurationData.redPacketUUid || '', // 红包uuid
        isTest: this.configurationData.isTest || 'yes', // 是否测试环境

        dest_appid: this.configurationData?.destAppid || '',
        scene: String(this.$actInfo.activity_id),
      };
      const fontColor = this.configurationData.recordsFontColor;
      const pageSize = this.configurationData.popupPageSize || 6; // 每页记录数可配置,默认6
      const {
        recordsFontColor,
      } = this.configurationData;
      const {
        titleStyle = {
          color: '#BB6B2F',
          fontSize: '0.40rem',
          fontWeight: '500',
          fontFamily: '微软雅黑',
        }, operateStyle = {
          color: '#BB6B2F',
          fontSize: '0.24rem',
          fontWeight: '400',
          fontFamily: '微软雅黑',
        },
      } = this.styles;
      baseComponents.PackageClaimRedPacketRecords.showPackageClaimRedPacketRecords({
        fontColor,
        params,
        pageSize,
        option: Object.assign({}, this.dialogConfig, {
          header: '获奖记录',
          fotter: false,
          titleStyle,
          operateStyle,
          height: this.deviceMode === 'pc' ? '360px'
            : this.configurationData.popupHeightH5 || '6.85rem', // h5弹窗高度可配置,默认6.85rem
          width: this.deviceMode === 'pc' ? '720px'
            : this.configurationData.popupWidthH5 || '7.2rem', // h5弹窗宽度可配置,默认7.2rem
          dialogStyle: Object.assign({}, this.dialogConfig?.dialogStyle || {}, {
            color: recordsFontColor || '#000000',
            backgroundImage: `url(${this.configurationData?.packageClaimBackgroundImage})`,
          }),
        }),
      });
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
